import React, { PropsWithChildren } from 'react';
import { QueryResponse } from 'global';
import { useQuery } from '@apollo/client';
import { useFormContext } from 'react-hook-form';
import { creditSubmissionDecisionApi } from 'modules/creditSubmission';
import { CreditSubmissionDecisionViewModel } from '@trnsact/trnsact-shared-types';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';

import { DecisionAdapterProps } from './types';
import { Loading } from '../../components/Loading';
import { formInitialValues } from '../../../constants';
import { deskingDecisionMapper } from '../../../mappers';
import { FinanceProgramFormValues } from '../../../types';

export const DecisionAdapter = ({
  children,
  decisionId,
  formDefaultValues = formInitialValues,
}: PropsWithChildren<DecisionAdapterProps>) => {
  const { reset } = useFormContext<FinanceProgramFormValues>();

  const { loading, error } = useQuery<
    { creditSubmissionDecision: QueryResponse<CreditSubmissionDecisionViewModel> },
    { id: string }
  >(creditSubmissionDecisionApi.getById, {
    variables: {
      id: decisionId!,
    },
    onCompleted(response) {
      const { entity } = response.creditSubmissionDecision.result;

      const formData = deskingDecisionMapper.processDecisionToDeskingForm(formDefaultValues, entity);

      reset(formData);
    },
  });

  return <RenderWithFallback children={children} fallBack={<Loading />} isLoading={loading} error={error} />;
};
